var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVersionLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.166 14.25v-.888a2.25 2.25 0 111.5 0v.888a.75.75 0 11-1.5 0zm1.167-3.623a.75.75 0 10-.834 1.244.75.75 0 00.834-1.244z",
    fill: "#6A7590"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.537 17.121a3 3 0 01-2.121.879h-9a3 3 0 01-3-3V9a3 3 0 013-3V4.5a4.5 4.5 0 019 0V6a3 3 0 013 3v6a3 3 0 01-.879 2.121zM5.795 2.38A3 3 0 004.916 4.5V6h6V4.5a3 3 0 00-5.121-2.121zm-3.44 5.56c-.28.282-.439.663-.439 1.061v6a1.499 1.499 0 001.5 1.5h9a1.508 1.508 0 001.06-.44c.282-.28.44-.662.44-1.06V9a1.5 1.5 0 00-1.5-1.5h-9a1.5 1.5 0 00-1.06.44z",
    fill: "#6A7590"
  })));
}
export default __webpack_public_path__ + "static/version-lock-icon.79bdff72.svg";
export { SvgVersionLockIcon as ReactComponent };